export const EIP1193_ERROR_CODES = {
    userRejectedRequest: {
        code: 4001,
        message: "The user rejected the request.",
    },
};
export class EIP1193Error extends Error {
    eip1193Error;
    constructor(eip1193Error) {
        super(eip1193Error.message);
        this.eip1193Error = eip1193Error;
    }
    toJSON() {
        return this.eip1193Error;
    }
}
export const serializeError = (err) => JSON.parse(JSON.stringify(err));
//# sourceMappingURL=EIP1193Error.js.map